import React, { useEffect, useState } from 'react';

import { imageZoom } from 'utils/zoomImage';
import { IImageProps } from 'store/modules/product';

import * as S from './styles';

interface GalleryProps {
  images: IImageProps[];
  classNameContainer?: string;
}

export function Gallery({ images, classNameContainer = '' }: GalleryProps) {
  const [counter, setCounter] = useState(1);

  function prevGallery() {
    if (counter === 0) return null;

    const itemGallery: any = document.querySelector(
      '#gallery-product .image-carousel',
    );

    const itemGalleryHeight = itemGallery.offsetHeight + 30;

    const valueTranslate =
      counter === 1 ? 0 : itemGalleryHeight * (counter - 1);

    const scroller = document.getElementById('scroller');
    scroller.style.transform = 'translateY(-' + valueTranslate + 'px)';

    setCounter(old => old - 1);
  }

  function nextGallery() {
    const itemsGallery = document.querySelectorAll(
      '#gallery-product .image-carousel',
    );

    if (itemsGallery.length === counter - 1 + 5 || itemsGallery.length <= 5) {
      return null;
    }

    const itemGallery: any = document.querySelector(
      '#gallery-product .image-carousel',
    );
    const itemGalleryHeight = itemGallery.offsetHeight + 30;
    const scroller = document.getElementById('scroller');

    if (counter === 0)
      scroller.style.transform = 'translateY(-' + itemGalleryHeight + 'px)';
    else
      scroller.style.transform =
        'translateY(-' + itemGalleryHeight * counter + 'px)';

    setCounter(old => old + 1);
  }

  function setSrcInPrincipalImage(element) {
    const itemsGallery: any = document.querySelectorAll(
      '#gallery-product .image-carousel',
    );
    const itemToActive: any = document.getElementById(element);

    for (let item of itemsGallery) {
      item.classList.remove('active');
    }

    if (itemToActive) {
      itemToActive.classList.add('active');
      (document.getElementById('product-image') as any).src = itemToActive.src;
    }

    imageZoom('product-image', 'resul-zoom-product');
  }

  useEffect(() => {
    setTimeout(() => {
      setSrcInPrincipalImage(images[0].grande);
    }, 1000);
  }, [images]);

  return (
    <S.Container id="gallery" className={`gallery${classNameContainer}`}>
      {images.length > 5 && (
        <>
          <span
            className="chevron-icon up black"
            title="Voltar"
            onClick={prevGallery}
          />
          <span
            className="chevron-icon down black"
            title="Próximo"
            onClick={nextGallery}
          />
        </>
      )}

      <div id="gallery-product" className="left-carousel">
        <div id="scroller">
          {images.map((i, index) => (
            <img
              key={index}
              id={i.grande}
              className="image-carousel active"
              onClick={() => setSrcInPrincipalImage(i.grande)}
              loading="lazy"
              src={i.grande}
              alt={i.grande}
            />
          ))}
        </div>
      </div>
    </S.Container>
  );
}
